exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".login-card__verification-desc--email[data-v-1605540a]{font-weight:900!important;text-decoration:underline;white-space:nowrap;color:#575657}.login-card__title[data-v-1605540a]{margin-bottom:1rem}.login-card__title-box[data-v-1605540a]{gap:.5rem!important}", ""]);

// exports
